import React, { useState, useRef } from "react";
import { Row, Col, Typography, Table, Dropdown, Menu, Icon, Modal, Button, Tag } from "antd";

import { resolveInaamCardLinkRequestApi, deleteInaamCardLinkRequestApi, verifyInaamCardLinkRequestApi } from "utils/apiService";

const { Text } = Typography;

export default function CardComplaintsTable(props) {
	const { data } = props;

	const [deleteModal, setDeleteModal] = useState(false);
	const deleteLinkRequests = useRef([]);

	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const rowSelection = {
		selectedRowKeys,
		onChange: (selectedRowKeys) => {
			props.handleRowSelection(selectedRowKeys);
			setSelectedRowKeys(selectedRowKeys);
		},
	};

	const columns = [
		{
			title: "Raised By",
			dataIndex: ["user"],
			key: "raisedBy",
			render: (row) => {
				return (
					<Row type="flex" style={{ flexDirection: "column" }}>
						<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", whiteSpace: "nowrap" }}>
							{row.name ? row.name : "-"}
						</Text>
						{row.contactNumber ? <Text style={{ fontStyle: "normal", fontSize: "14px", lineHeight: "24px" }}>{row.contactNumber}</Text> : null}
					</Row>
				);
			},
		},
		{
			title: "Current Banat Al Nujoom Card No.",
			dataIndex: "card_number",
			key: "card_number",
			render: (rewardCardNumber) => (
				<Text style={{ fontStyle: "normal", fontSize: "16px", lineHeight: "24px", fontWeight: "bold", color: "#181818" }}>
					{rewardCardNumber ? rewardCardNumber : ""}
				</Text>
			),
		},
		{
			title: "Card Holder Name",
			dataIndex: "card_holder_name",
			key: "card_holder_name",
			// render: (vm) => {
			// 	return <Text>{vm == "phone" ? "Contact Number" : vm == "email" ? "Email Address" : "Banat Al Nujoom  Card Number"}</Text>;
			// },
		},
		{
			title: "Verification Data",
			dataIndex: "verification_data",
			key: "verification_data",
			render: (_, row) => {
				return (
					<Row type="flex" style={{ flexDirection: "column" }}>
						<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>
							{row.verification_data ? row.verification_data : "-"}
						</Text>
						<Text>
							{row.verification_data === "phone" ? "Contact Number" : row.verification_data === "email" ? "Email Address" : "Banat Al Nujoom  Card Number"}
						</Text>
					</Row>
				);
			},
		},
		// {
		// 	title: "Request Type",
		// 	dataIndex: "type",
		// 	key: "type",
		// 	render: (rt) => {
		// 		return (
		// 			<Tag color={rt === "Link Request" ? "geekblue" : rt === "Merge Request" ? "megenta" : "default"}>
		// 				{rt === "Link Request" ? "Link Card" : rt === "Merge Request" ? "Merge Cards" : "default"}
		// 			</Tag>
		// 		);
		// 	},
		// },
		// {
		// 	title: "Verification",
		// 	dataIndex: "is_verified",
		// 	key: "isVerified",
		// 	render: (isVerified, row) => {
		// 		return (
		// 			<Dropdown
		// 				placement={"bottomRight"}
		// 				overlay={
		// 					<Menu>
		// 						<Menu.Item
		// 							onClick={() => {
		// 								verifyInaamCardLinkRequestApi({
		// 									requestData: {
		// 										cardLinkRequestUuid: [row.uuid],
		// 										status: "notverified",
		// 									},
		// 									res200Callback: () => {
		// 										props.updatePage(data.pageNum);
		// 									},
		// 								});
		// 							}}>
		// 							<Text style={{ color: "#181818" }}>Not Verified {!isVerified && <Icon type="check" />}</Text>
		// 						</Menu.Item>
		// 						<Menu.Item
		// 							onClick={() => {
		// 								verifyInaamCardLinkRequestApi({
		// 									requestData: {
		// 										cardLinkRequestUuid: [row.uuid],
		// 										status: "verified",
		// 									},
		// 									res200Callback: () => {
		// 										props.updatePage(data.pageNum);
		// 									},
		// 								});
		// 							}}>
		// 							<Text style={{ color: "#181818" }}>Verified {isVerified && <Icon type="check" />}</Text>
		// 						</Menu.Item>
		// 					</Menu>
		// 				}>
		// 				<Tag color={isVerified ? "green" : "blue"}>
		// 					{isVerified ? "Verified" : "Not Verified"} <Icon type="down" style={isVerified?{ color: "#52c41a" }:{ color: "#1890ff" }} />
		// 				</Tag>
		// 			</Dropdown>
		// 		);
		// 	},
		// },
		{
			title: "Raised On",
			dataIndex: "date_created",
			render: (raisedOn) => <div style={{ width: "135px" }}>{raisedOn}</div>,
		},
		{
			title: "",
			dataIndex: "uuid",
			key: "uuid",
			render: (uuid) => {
				return (
					<Dropdown
						placement={"bottomLeft"}
						overlay={
							<Menu>
								<Menu.Item
									onClick={() => {
										resolveInaamCardLinkRequestApi({
											requestData: {
												card_link_requests_uuid: [uuid],
												status: props.noAction ? "unresolved" : "resolved",
											},
											res200Callback: () => {
												props.updatePage(data.pageNum);
											},
										});
									}}>
									<Text style={{ color: "#181818" }}>Mark as {props.noAction ? "unresolved" : "resolved"}</Text>
								</Menu.Item>
								<Menu.Item
									onClick={() => {
										deleteLinkRequests.current = [uuid];
										setDeleteModal(true);
									}}>
									<Text style={{ color: "#F5222D" }}>Delete</Text>
								</Menu.Item>
							</Menu>
						}>
						<Icon
							type="more"
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ fontSize: "16px", color: "#747474", marginLeft: "52px" }}
						/>
					</Dropdown>
				);
			},
		},
	];

	// return data.cardLinkRequests?.length ? (
	return (
		<>
			<Table
				rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }

					return columns;
				})()}
				dataSource={data.cardLinkRequests}
				pagination={{ showQuickJumper: true, current: data.pageNum, pageSize: data.pageSize, total: data.pageSize * data.totalPages }}
				style={{ marginTop: "-10px" }}
				onChange={(pagination) => {
					props.updatePage(pagination.current);
				}}
				loading={props.loading}
			/>
			<Modal centered visible={deleteModal} destroyOnClose maskClosable={false} onCancel={() => setDeleteModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="delete"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Delete item
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>Are you sure you want to delete this Card Link Request?</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setDeleteModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#C91713",
									color: "#FFFFFF",
								}}
								onClick={() => {
									deleteInaamCardLinkRequestApi({
										requestData: {
											card_link_requests_uuid: deleteLinkRequests.current,
										},
										res200Callback: () => {
											setDeleteModal(false);
											props.updatePage(data.pageNum);
										},
									});
								}}>
								Delete
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
		</>
	);
	// ) : (
	// 	<>
	// 		<Empty activeKey={props.noAction ? true : false} />
	// 	</>
	// );
}
